<template>
  <div>
    <div class="flex flex-row h-10 bg-white flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest">
      <div class="self-center ml-4 text-sm">Forms</div>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/common/TextField'
export default {
  components: {
    TextField
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Customer/Forms.vue